import { render, staticRenderFns } from "./deductAdd.vue?vue&type=template&id=31af01be&scoped=true"
import script from "./deductAdd.vue?vue&type=script&lang=js"
export * from "./deductAdd.vue?vue&type=script&lang=js"
import style0 from "./deductAdd.vue?vue&type=style&index=0&id=31af01be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31af01be",
  null
  
)

export default component.exports